import React, { useEffect, useState } from 'react'
import { MenuItemType } from '@utils/types'
import styles from './SideMenu.module.sass'
import { WLink } from '@components/atoms'

interface Props {
  className?: string
}

const SideMenu = (props: Props) => {
  const { className = '' } = props

  const [activeItemId, setActiveItemId] = useState(undefined)
  const [items, setItems] = useState([])

  useEffect(() => {
    const findItems = () => {
      setItems(
        [...document.getElementsByClassName('menu-item-section')].map((x, index) => ({
          pk: [...document.getElementsByClassName('menu-item-section-ref')]?.[index]?.id,
          index: index,
          name: [...document.getElementsByClassName('menu-item-section-label')]?.[index]
            ?.textContent,
        }))
      )
    }

    findItems()
    // a volte non carica subito
    setTimeout(() => {
      if (!items?.length) findItems()
    }, 1000)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      setActiveItemId(
        items?.filter((x) => {
          const el = [...document.getElementsByClassName('menu-item-section')]?.[x.index]
          const ref = [...document.getElementsByClassName('menu-item-section-ref')]?.[x.index]
          return (
            ref.getBoundingClientRect().top + el.getBoundingClientRect().height > 0 &&
            el.getBoundingClientRect().top <= window.innerHeight
          )
        })?.[0]?.pk
      )
    }
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [items])

  const scrollToRef = (e, item) => {
    e.preventDefault()
    const ref = [...document.getElementsByClassName('menu-item-section-ref')]?.[item.index]
    window.scrollTo({
      top: ref.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth',
    })
  }

  return items?.length ? (
    <div className={`${styles.root} ${className}`}>
      <ol className={styles.list}>
        {items.map((x) => (
          <li
            key={x.pk}
            className={`${styles.item} ${activeItemId === x.pk ? styles['item--active'] : ''}`}
          >
            <WLink href={`#${x.pk}`} className={styles.link} onClick={(e) => scrollToRef(e, x)}>
              <span className={styles.label}>{x.name}</span>
            </WLink>
          </li>
        ))}
      </ol>
    </div>
  ) : (
    <></>
  )
}

export default SideMenu
